<ng-container>
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            {{data.modalTitle}}
        </h4>
    </div>
    <div class="modal-body ng-pdf-viewer">
          <object *ngIf="active_slide == 1"
            style="width:100%;height:100%"
            type="application/pdf"
            [data]="pdfURL">
          </object>

        <div class="slide ani-section centered-content with-top-padding in-view" *ngIf="active_slide == 2" >
            <div class="centered-middle-content">
                <div class="form no-style with-right-margin" *ngIf="print_and_post_message != null">
                    <div class="panel-loading">
                        <div class="pending-icon" loading></div>
                        <span class="ss-check"></span>
                        <p style="margin-bottom: 35px;">{{print_and_post_message}}</p>
                    </div>
                </div>
                <div class="form no-style with-right-margin" *ngIf="print_and_post_error_message != null">
                    <div class="panel-loading">
                        <div class="pending-icon" loading></div>
                        <span class="ss-alert"></span>
                        <p style="margin-top: 30px;">{{print_and_post_error_message}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--panel footer-->
    <div class="modal-footer page-panel-actions with-slides ">
        <div class="slide-button buttons" [ngClass]="{'in-view' : active_slide === 1}">
        <label class="copy-label" *ngIf="supports_copy">
            <input type="checkbox" [(ngModel)]="isCopy" class="inline-checkbox above" [ngModelOptions]="{standalone: true}" (change)="checkSupportCopy(isCopy)"><span translate>This.is.a.copy</span>
        </label>
            <button class="btn btn-primary primary-button with-left-margin" *ngIf="supports_print_post" (click)="printPost(); slideInView(2)" translate>Print.and.Post</button>
            <button *ngIf="showPrint" class="btn btn-primary primary-button with-left-margin" (click)="print()" translate>Print</button>
            <button *ngIf="showEmailButton" (click)="bsModalRef.hide();triggerSendEmail($event);" class="btn btn-primary primary-button mr20" translate>Email</button>
        </div>
        <div class="slide-button buttons" [ngClass]="{'in-view' : active_slide === 2}">
        <a href="javascript:void(0)" class="btn" (click)="sidePanelModalRef.hide()">Close</a>
        </div>
    </div>
</ng-container>
